import { render, staticRenderFns } from "./RegisteredProducts.vue?vue&type=template&id=1db4d726&scoped=true"
import script from "./RegisteredProducts.vue?vue&type=script&lang=js"
export * from "./RegisteredProducts.vue?vue&type=script&lang=js"
import style0 from "./RegisteredProducts.vue?vue&type=style&index=0&id=1db4d726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4d726",
  null
  
)

export default component.exports